import styled from '@emotion/styled';

export const Canvas = styled.canvas`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: ${(props) =>
    !props.path || props.path === 'groundwater' || props.path === 'surface'
      ? 1
      : 0.6};
  transition: opacity 0.2s linear;
`;
